export default __webpack_public_path__ + "static/media/logo-horizontal-removebg.2d555a93.webp";